import {
  OrderError,
  mapOrderPayloadTypeToErrorCode,
} from '../usecases/Errors/customErrors';

export const handleOrderErrorPayload = (
  orderErrorPayloadTypename: string,
  orderErrorPayloadMessage: string,
) => {
  if (
    [
      'OrderExpiredError',
      'OrderNotFoundError',
      'OrderInvalidError',
      'PromotionInvalidError',
    ].includes(orderErrorPayloadTypename)
  ) {
    throw new OrderError(
      orderErrorPayloadMessage,
      mapOrderPayloadTypeToErrorCode[orderErrorPayloadTypename],
    );
  }
};
